// extracted by mini-css-extract-plugin
export default {"sidebarsubstepentry":"sidebar-substep-entry_sidebarsubstepentry__lHmW+"};